import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GLOBALTYPES } from "../redux/actions/globalTypes";
import { getDataAPI } from "../utils/fetchData";
import Adminnavbar from "./adminnavbar";
import Footer from "./footer";
import LoginRequest from "./loginRequest";
import Sidenavbar from "./sidenav";

// Constants for styles
const CONTAINER_STYLE = { backgroundColor: "#ffffff", padding: "30px" };
const DASHBOARD_ROW_STYLE = {
	paddingTop: "20px",
	paddingBottom: "20px",
	backgroundImage: "linear-gradient(#a7d588,#c9e6bb)",
};

const DASHBOARD_CARDS = [
	{ key: "totalusers", label: "Total Users", bgColor: "#24A2B3" },
	{ key: "maleusers", label: "Male Users", bgColor: "#E96CB4" },
	{ key: "femaleusers", label: "Female Users", bgColor: "#7F2DA2" },
];

const Usermanagement = () => {
	const { auth } = useSelector((state) => state);
	const [userDetails, setUserDetails] = useState({});
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const dispatch = useDispatch();

	useEffect(() => {
		const fetchUserDetails = async () => {
			try {
				dispatch({ type: GLOBALTYPES.ALERT, payload: { loading: true } });
				setLoading(true);
				setError(null);

				const res = await getDataAPI(`getuserscount`);
				setUserDetails(res.data.userdetails || {});
			} catch (err) {
				setError("Failed to load user details");
				console.error("Error fetching user details:", err);
			} finally {
				setLoading(false);
				dispatch({
					type: GLOBALTYPES.ALERT,
					payload: { loading: false },
				});
			}
		};

		fetchUserDetails();
	}, [dispatch]);

	// Memoize dashboard cards to prevent unnecessary re-renders
	const dashboardCards = useMemo(() => {
		return DASHBOARD_CARDS.map((card) => (
			<div
				key={card.key}
				className="col text-format"
				style={{ backgroundColor: card.bgColor }}>
				<div className="text1">{userDetails[card.key] || 0}</div>
				<div className="text1">{card.label}</div>
			</div>
		));
	}, [userDetails]);

	if (!auth.user) {
		return <LoginRequest />;
	}

	return (
		<>
			<Adminnavbar />
			<div style={CONTAINER_STYLE}>
				<div className="dashboard-text">Super Admin Dashboard</div>
				<div id="admin">
					<div>
						<div className="row format">
							<Sidenavbar />
							<div className="col-8">
								{loading ? (
									<div className="text-center p-4">
										Loading user statistics...
									</div>
								) : error ? (
									<div className="text-center p-4 text-danger">{error}</div>
								) : (
									<div className="row format" style={DASHBOARD_ROW_STYLE}>
										{dashboardCards}
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
			<Footer />
		</>
	);
};

export default Usermanagement;
